<div class="analyticsPopover">
	<ion-list lines="none">
		<ion-item lines="none" class="link" (click)="go('yesterday', 'Yesterday')">
			<label class="link" data-cy="analyticsPopup-yesterday">Yesterday</label>
		</ion-item>
		<ion-item lines="none" class="link" (click)="go('7daysAgo', '7 days ago')">
			<label class="link" data-cy="analyticsPopup-sevenDaysAgo">7 days ago</label>
		</ion-item>
		<ion-item lines="none" class="link" (click)="go('30daysAgo', '30 days ago')">
			<label class="link" data-cy="analyticsPopup-thirtyDaysAgo">30 days ago</label>
		</ion-item>
		<ion-item lines="none" class="link" (click)="go('60daysAgo', '60 days ago')">
			<label class="link" data-cy="analyticsPopup-sixtyDaysAgo">60 days ago</label>
		</ion-item>
		<ion-item lines="none" class="link" (click)="go('','Lifetime')">
			<label class="link" data-cy="analyticsPopup-lifetime">Lifetime</label>
		</ion-item>
	</ion-list>
</div>